/**
 * BackToDashBar — Phase 31 (2026-07-17)
 *
 * A single, reusable "← Back to Dashboard" bar. Appears on any page when
 * the URL carries `?from=dashboard` OR when the caller explicitly mounts
 * it. Matches the styling of the working /dashboard/expenses breadcrumb.
 */
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackToDashBar({ force = false }) {
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const show = force || params.get("from") === "dashboard";
  if (!show) return null;
  return (
    <div className="mb-3" data-testid="back-to-dashboard-bar">
      <Link
        to="/dashboard"
        className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#4FA3D1]"
        data-testid="back-to-dashboard"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Back to Dashboard
      </Link>
    </div>
  );
}
